module.exports = __webpack_public_path__ + "static/media/logo-white.f053e82a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-white.svg
// module id = 234
// module chunks = 0